// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1162":"b478a885","2643":"037f3a08","4776":"0b465130","5679":"37424505"}[chunkId] || chunkId) + "." + {"1162":"30c7a108d182c5dc","1484":"487809257ab604cb","2643":"0d52295304d92eca","4618":"3a2c87cba5c2988e","4776":"139859c844f1817e","5679":"aa007aaddbea3891","6094":"86f74ec2608849d8"}[chunkId] + ".js";
};